import { useCallback } from 'react';
import { useAppDispatch } from 'redux-store/hooks/useAppDispatch';
import { useAppSelector } from 'redux-store/hooks/useAppSelector';
import { useSetAtom } from 'jotai';
import { handleSetCompanyId, handleDeleteCompanyId } from 'redux-store/slices/auth-slice';
import { selectedCompanyIdAtom } from 'atoms/company';
import { authSelector } from 'redux-store/selector';

export const useSelectedCompany = () => {
  const dispatch = useAppDispatch();
  const setSelectedCompanyIdAtom = useSetAtom(selectedCompanyIdAtom);
  const { companyId } = useAppSelector(authSelector);

  const setCompanyId = useCallback((id: string) => {
    // Update Redux
    dispatch(handleSetCompanyId(id));
    // Update Jotai atom
    setSelectedCompanyIdAtom(id);
    // Update localStorage
    localStorage.setItem('company-id', id);
  }, [dispatch, setSelectedCompanyIdAtom]);

  const clearCompanyId = useCallback(() => {
    // Update Redux
    dispatch(handleDeleteCompanyId());
    // Update Jotai atom
    setSelectedCompanyIdAtom(null);
    // Update localStorage
    localStorage.removeItem('company-id');
  }, [dispatch, setSelectedCompanyIdAtom]);

  return {
    companyId,
    setCompanyId,
    clearCompanyId,
  };
};
